import React, { createContext, useContext, useState } from "react";

const initialData = localStorage.getItem("assessmentData")
  ? JSON.parse(localStorage.getItem("assessmentData"))
  : {};

const AssessmentContext = createContext();

export const AssessmentProvider = ({ children }) => {
  const [assessmentData, setAssessmentData] = useState(initialData);
  const [sessionId, setSessionId] = useState(null);

  const updateAssessmentData = (updates) => {
    setAssessmentData((prev) => ({
      ...prev,
      ...updates,
    }));
  };

  const resetAssessmentData = () => {
    setAssessmentData({});
    setSessionId(null);
    localStorage.removeItem("assessmentData");
  };

  return (
    <AssessmentContext.Provider
      value={{ assessmentData, updateAssessmentData, resetAssessmentData, sessionId, setSessionId }}
    >
      {children}
    </AssessmentContext.Provider>
  );
};

export const useAssessment = () => useContext(AssessmentContext);
